import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import BackArrow from '../../assets/icons/BackArrow';
import { vehicleContext } from '../VehicleProvider';
import { Container, BackToResultsCTA, VehicleDetailsPageWrapper } from './BackButtonBar.styles';
import useBackUrl from '../../hooks/useBackUrl';
import { Layout, Text } from '@oneaudi/unified-web-components';

const Index: React.FC = () => {
  const { vehicle, loading } = useContext(vehicleContext);
  const { t } = useTranslation();
  const { BACK_URL } = useBackUrl();

  // The list page feature app will reload the filters previously set from local storage
  const handleBackClick = () => {
    window.location.href = BACK_URL;
  };

  return vehicle || loading ? (
    <VehicleDetailsPageWrapper>
      <Container data-testid="back-to-results-container">
        <BackToResultsCTA onClick={handleBackClick} data-testid="back-to-results-button">
          <Layout margin={['0', '13px', '0', '0']}>
            <BackArrow />
          </Layout>
          <Text
            variant={{
              style: 'bold',
              order: '1',
              type: 'copy',
            }}
          >
            {t('backButtonBar.cta')}
          </Text>
        </BackToResultsCTA>
      </Container>
    </VehicleDetailsPageWrapper>
  ) : null;
};

export default Index;
